// Maison Dodji — official product mapping (visuals provided by client).
// Bilingual: each text field carries { fr, en }.

export const PRODUCTS = [
  {
    slug: "rosa",
    name: "Rosa",
    capacity: 1,
    capacityLabel: {
      fr: "Une montre automatique",
      en: "One automatic watch",
    },
    price: 3500,
    priceLabel: {
      fr: "À partir de 3\u00A0500\u00A0€",
      en: "From €3,500",
    },
    tagline: {
      fr: "L'essentiel, dans sa forme la plus pure.",
      en: "The essential, in its purest form.",
    },
    silhouette: {
      fr: "Présence circulaire — compacte et silencieuse.",
      en: "A circular presence — compact and silent.",
    },
    image:
      "https://customer-assets.emergentagent.com/job_collection-privee/artifacts/ankqs57d_IMG-20260125-WA0003.jpg",
    description: {
      fr:
        "Rosa condense l'esprit de Maison Dodji dans une présence circulaire, compacte et silencieuse. C'est une pièce de justesse\u00A0: celle que l'on choisit lorsque l'on recherche moins l'effet que l'évidence. Une montre mécanique automatique y trouve sa place.",
      en:
        "Rosa distills the spirit of Maison Dodji into a circular, compact and silent presence. It is a piece of precision — chosen not for effect, but for obviousness. A mechanical automatic watch finds its place within it.",
    },
    specs: {
      fr: [
        "Fabrication française",
        "Structure en bois laqué",
        "Plaque en métal gravé",
        "1 module mécanique suisse",
        "Diamètre 220 mm × profondeur 120 mm",
      ],
      en: [
        "French craftsmanship",
        "Lacquered wood structure",
        "Engraved metal plate",
        "1 Swiss mechanical module",
        "Diameter 220 mm × depth 120 mm",
      ],
    },
  },
  {
    slug: "daisuki",
    name: "Daisuki",
    capacity: 2,
    capacityLabel: {
      fr: "Deux montres automatiques",
      en: "Two automatic watches",
    },
    price: 5500,
    priceLabel: {
      fr: "À partir de 5\u00A0500\u00A0€",
      en: "From €5,500",
    },
    tagline: {
      fr: "La pièce du duo.",
      en: "The piece for two.",
    },
    silhouette: {
      fr: "Forme cœur — généreuse, immédiatement singulière.",
      en: "Heart-shaped form — generous, immediately singular.",
    },
    image:
      "https://customer-assets.emergentagent.com/job_collection-privee/artifacts/pragq6vb_IMG-20260125-WA0002.jpg",
    description: {
      fr:
        "Daisuki introduit une présence plus affective et plus sculpturale. Sa forme reconnaissable, généreuse et immédiatement singulière accueille deux montres mécaniques automatiques — pour ceux qui souhaitent faire dialoguer deux garde-temps.",
      en:
        "Daisuki introduces a more affective and sculptural presence. Its recognizable, generous and immediately singular form welcomes two mechanical automatic watches — for those who wish to place two timepieces in dialogue.",
    },
    specs: {
      fr: [
        "Fabrication française",
        "Structure en bois laqué",
        "Plaque et pieds en métal or clair",
        "2 modules mécaniques suisses",
        "Largeur 278,5 mm × hauteur 274,5 mm × profondeur 123,3 mm",
      ],
      en: [
        "French craftsmanship",
        "Lacquered wood structure",
        "Light gold metal plate and feet",
        "2 Swiss mechanical modules",
        "Width 278.5 mm × height 274.5 mm × depth 123.3 mm",
      ],
    },
  },
  {
    slug: "lumumba",
    name: "Lumumba",
    capacity: 3,
    capacityLabel: {
      fr: "Trois montres automatiques",
      en: "Three automatic watches",
    },
    price: 8000,
    priceLabel: {
      fr: "À partir de 8\u00A0000\u00A0€",
      en: "From €8,000",
    },
    tagline: {
      fr: "La ligne et l'assise.",
      en: "Line and grounding.",
    },
    silhouette: {
      fr: "Lecture horizontale — stable et architecturée.",
      en: "Horizontal reading — stable and architectural.",
    },
    image:
      "https://customer-assets.emergentagent.com/job_collection-privee/artifacts/8p6wa68w_IMG-20260125-WA0006.jpg",
    description: {
      fr:
        "Avec sa lecture horizontale, Lumumba apporte une dimension plus architecturée à la collection. Il installe une ligne stable et calme, idéale pour un bureau, un salon ou un intérieur où la présence doit s'affirmer avec retenue. Trois montres mécaniques automatiques y trouvent leur rythme.",
      en:
        "With its horizontal reading, Lumumba brings a more architectural dimension to the collection. It establishes a stable and calm line, ideal for an office, a sitting room, or any interior where presence must assert itself with restraint. Three mechanical automatic watches find their rhythm within it.",
    },
    specs: {
      fr: [
        "Fabrication française",
        "Structure en bois laqué",
        "Plaque métallique gravée",
        "3 modules mécaniques suisses",
        "Largeur 340 mm × hauteur 140 mm × profondeur 120 mm",
      ],
      en: [
        "French craftsmanship",
        "Lacquered wood structure",
        "Engraved metal plate",
        "3 Swiss mechanical modules",
        "Width 340 mm × height 140 mm × depth 120 mm",
      ],
    },
  },
  {
    slug: "sankara",
    name: "Sankara",
    capacity: 3,
    capacityLabel: {
      fr: "Trois montres automatiques",
      en: "Three automatic watches",
    },
    price: 8500,
    priceLabel: {
      fr: "À partir de 8\u00A0500\u00A0€",
      en: "From €8,500",
    },
    tagline: {
      fr: "L'horizontalité comme signature.",
      en: "Horizontality as signature.",
    },
    silhouette: {
      fr: "Présence allongée — plus étirée, plus affirmée.",
      en: "Elongated presence — more drawn out, more asserted.",
    },
    image:
      "https://customer-assets.emergentagent.com/job_collection-privee/artifacts/3d83wdwc_IMG-20260125-WA0005.jpg",
    description: {
      fr:
        "Plus étiré, plus affirmé, Sankara pousse plus loin encore l'idée du meuble singulier comme présence silencieuse. Il convient à ceux qui souhaitent une pièce plus manifeste, capable de structurer un lieu sans jamais l'alourdir.",
      en:
        "More elongated, more asserted, Sankara pushes further the idea of singular furniture as a silent presence. It suits those who seek a more declared piece, capable of structuring a space without ever weighing it down.",
    },
    specs: {
      fr: [
        "Fabrication française",
        "Structure en bois laqué",
        "Plaque en métal gravé",
        "3 modules mécaniques suisses",
        "Largeur 400 mm × hauteur 130 mm × profondeur 120 mm",
      ],
      en: [
        "French craftsmanship",
        "Lacquered wood structure",
        "Engraved metal plate",
        "3 Swiss mechanical modules",
        "Width 400 mm × height 130 mm × depth 120 mm",
      ],
    },
  },
  {
    slug: "quincy",
    name: "Quincy",
    capacity: 4,
    capacityLabel: {
      fr: "Quatre montres automatiques",
      en: "Four automatic watches",
    },
    price: 10000,
    priceLabel: {
      fr: "À partir de 10\u00A0000\u00A0€",
      en: "From €10,000",
    },
    tagline: {
      fr: "La densité du quatuor.",
      en: "The density of the quartet.",
    },
    silhouette: {
      fr: "Forme carrée — la pièce la plus dense de la collection.",
      en: "Square form — the most concentrated piece in the collection.",
    },
    image:
      "https://customer-assets.emergentagent.com/job_collection-privee/artifacts/vy8a0ejc_IMG-20260125-WA0004.jpg",
    description: {
      fr:
        "Quincy est la pièce la plus dense de la collection régulière. Il s'adresse aux collectionneurs et aux intérieurs assumés, là où l'objet ne se contente plus d'accompagner l'espace mais participe pleinement à son caractère. Quatre montres mécaniques y trouvent leur place.",
      en:
        "Quincy is the most concentrated piece in the regular collection. It speaks to collectors and assured interiors — where the object no longer simply accompanies a space, but fully contributes to its character. Four mechanical watches find their place within it.",
    },
    specs: {
      fr: [
        "Fabrication française",
        "Structure en bois laqué",
        "Plaque en métal gravé",
        "4 modules mécaniques suisses",
        "Largeur 245 mm × hauteur 235 mm × profondeur 120 mm",
      ],
      en: [
        "French craftsmanship",
        "Lacquered wood structure",
        "Engraved metal plate",
        "4 Swiss mechanical modules",
        "Width 245 mm × height 235 mm × depth 120 mm",
      ],
    },
  },
];

export const getProduct = (slug) => PRODUCTS.find((p) => p.slug === slug);
export const getOtherProducts = (slug) => PRODUCTS.filter((p) => p.slug !== slug);
